import SettingBase from '../settings/util/SettingBase'

class ServiceTicketPartsController extends SettingBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.$state = $state;
        this.id = "service-ticket-parts";
        this.acl = {};
        this.hasACL = {};
    }

    $onInit() {
        super.$onInit()
        for (let key in this.acl['setting-' + this.id]) {
            this.hasACL[this.acl['setting-' + this.id][key]] = true;
        }
    }
}

export default ServiceTicketPartsController;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/service_ticket_parts.controller.js